// ============================================================
// CustomFilterModal.jsx — name + save the current edit as a filter
// ------------------------------------------------------------
// Shows a live preview of the current settings on the selected photo and a
// name field. On save, hands back the name + a 60×60 thumbnail data URL so
// usePhotoEditor can persist it to custom_filters.
// ============================================================

import React, { useEffect, useState } from 'react';
import { loadImage, renderThumbnail } from '../../utils/canvasExport';
import { buildPreviewCSS } from '../../utils/filterEngine';

export default function CustomFilterModal({ open, photoUrl, settings, onSave, onClose }) {
  const [name, setName] = useState('');
  const [thumb, setThumb] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) { setName(''); setThumb(null); setBusy(false); return; }
    let alive = true;
    if (photoUrl) {
      loadImage(photoUrl)
        .then((img) => { if (alive) setThumb(renderThumbnail(img, settings, 60)); })
        .catch(() => { /* fall back to CSS preview */ });
    }
    return () => { alive = false; };
  }, [open, photoUrl, settings]);

  if (!open) return null;

  const handleSave = async () => {
    if (!name.trim()) return;
    setBusy(true);
    await onSave(name.trim(), thumb);
    setBusy(false);
  };

  return (
    <div className="pe-modal-backdrop" onClick={busy ? undefined : onClose}>
      <div className="pe-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pe-modal-title">Save current edit as filter</div>
        <div className="pe-modal-sub">Reuse this look on any photo from the Filters tab.</div>

        <div className="pe-cf-row">
          <div className="pe-cf-preview">
            {thumb
              ? <img src={thumb} alt="preview" />
              : photoUrl
                ? <img src={photoUrl} alt="preview" style={{ filter: buildPreviewCSS(settings) }} />
                : <span className="pe-filter-thumb-ph" />}
          </div>
          <input
            className="pe-text-input pe-cf-name"
            placeholder="Filter name (e.g. Café Warm)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
            maxLength={40}
            onKeyDown={(e) => { if (e.key === 'Enter') handleSave(); }}
          />
        </div>

        <div className="pe-modal-foot">
          <button className="pe-btn pe-btn-ghost" disabled={busy} onClick={onClose}>Cancel</button>
          <button className="pe-btn pe-btn-primary" disabled={busy || !name.trim()} onClick={handleSave}>
            {busy ? 'Saving…' : 'Save filter'}
          </button>
        </div>
      </div>
    </div>
  );
}
